const backendUrl = process.env.REACT_APP_BACKEND_URL;

if (!backendUrl) {
  throw new Error("REACT_APP_BACKEND_URL is required.");
}

export const apiUrl = `${backendUrl}/api`;

export async function request(path, options = {}, token = null) {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const response = await fetch(`${apiUrl}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(describeError(data.detail));
  }
  return data;
}

// Multipart upload. Deliberately does NOT set Content-Type: the browser has to
// generate it itself so it can append the multipart boundary — setting it by
// hand (as request() always does) makes the body unparseable server-side.
export async function uploadFile(path, file, token) {
  const body = new FormData();
  body.append("file", file);
  const response = await fetch(`${apiUrl}${path}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(describeError(data.detail));
  }
  return data;
}

// For binary responses (PDF letters, etc.) — request() assumes JSON, this
// doesn't. Triggers a normal browser file-save via a throwaway object URL.
export async function downloadFile(path, filename, token) {
  const response = await fetch(`${apiUrl}${path}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(describeError(data.detail));
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function describeError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail.map((issue) => issue.msg || issue.type).filter(Boolean).join(" ") || "Something went wrong. Please try again.";
  }
  return "Something went wrong. Please try again.";
}